import { motion } from "framer-motion"
import { TRANSITION } from "@/shared/lib/motion"
import { cn } from "@/shared/lib/utils"
import { Skeleton } from "./skeleton"

/** Быстрая загрузка не должна мигать заглушкой: она проявляется, только если код грузится дольше. */
const APPEAR_DELAY = 0.18

/**
 * Заглушка, пока грузится код страницы. С `shell` повторяет каркас PageShell: та же ширина,
 * надзаголовок, заголовок, кнопка справа, строка поиска и переключатель, поэтому страница
 * встаёт ровно на её место. Без `shell` это заглушка раздела внутри уже открытой страницы.
 */
export function PageSkeleton({ shell = false, className }: { shell?: boolean; className?: string }) {
	const body = (
		<>
			<Skeleton className="h-11 w-full rounded-2xl" />
			<div className="flex gap-1 overflow-hidden">
				{[64, 120, 96, 104].map((width) => (
					<Skeleton key={width} className="h-8 shrink-0 rounded-full" style={{ width }} />
				))}
			</div>
			<Skeleton className="h-72 w-full rounded-2xl" />
		</>
	)
	return (
		<motion.div
			role="status"
			aria-label="Загружаем раздел"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ ...TRANSITION.crossfade, delay: APPEAR_DELAY }}
			className={cn(shell && "relative isolate", className)}
		>
			{shell ? (
				<div className="container mx-auto max-w-6xl px-3 py-5 sm:px-6 lg:py-8">
					<div className="mb-6 flex flex-wrap items-end justify-between gap-x-4 gap-y-3 lg:mb-8">
						<div className="min-w-0 space-y-2">
							<Skeleton className="h-3 w-16 rounded" />
							<Skeleton className="h-7 w-44 rounded-lg sm:h-8" />
							<Skeleton className="h-4 w-80 max-w-full rounded" />
						</div>
						<Skeleton className="h-10 w-44 rounded-full" />
					</div>
					<div className="space-y-4">{body}</div>
				</div>
			) : (
				<div className="space-y-4">
					<Skeleton className="h-40 w-full rounded-2xl" />
					<Skeleton className="h-28 w-full rounded-2xl" />
				</div>
			)}
		</motion.div>
	)
}
